import { useLocation, useParams } from "react-router-dom";
import moment from "moment-timezone";

export function useUrlSearchParams() {
    const { search } = useLocation();
    const urlSearchParams = new URLSearchParams(search);
    return Object.fromEntries(urlSearchParams);
}

export function useWorkflowId() {
    const params = useParams();
    return params.workflowId || '';
}

const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const formatDateTime = (timestamp: string) => {
    return moment(timestamp).tz(timezone).format('DD MMM YY, HH:mm:ss');
};